import React from "react";
import { Spacer } from "./Spacer";
import { SpacerBaseProps, SpecializedSpacerComponent } from "./Spacer.types";

/**
 * VerticalSpacer - Creates vertical space in layouts
 *
 * @example
 * // Basic usage
 * <VerticalSpacer size="large" />
 *
 * // As a custom element with additional props
 * <VerticalSpacer as="div" size="medium" aria-hidden="true" />
 */

export const VerticalSpacer = function VerticalSpacer(
  props: Omit<SpacerBaseProps, "axis"> & { as?: React.ElementType }
) {
  const { as, ...rest } = props;
  return <Spacer as={as} axis="vertical" width="100%" {...rest} />;
} as SpecializedSpacerComponent;

// Set display name for debugging
VerticalSpacer.displayName = "VerticalSpacer";

export default VerticalSpacer;
